import React from 'react';

import Box from '../Box'

export default function ABridHeader(props) {

    return (
        <section className="container">
            <Box {...props} id="b1" type="ABridText" settings={props.settings.b1} preserveImageRatio={true} classes="" />
        </section>
    );
}